import { render, staticRenderFns } from "./CustomSingleColumTable.vue?vue&type=template&id=6e162495&scoped=true&"
import script from "./CustomSingleColumTable.vue?vue&type=script&lang=js&"
export * from "./CustomSingleColumTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomSingleColumTable.vue?vue&type=style&index=0&id=6e162495&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e162495",
  null
  
)

export default component.exports